import { isAxiosError } from 'axios';

/**
 * A request that got no answer at all — the connection is down or the server out of reach — as
 * opposed to an answer that refuses (401, 403, 404, 500…).
 *
 * Common's network rule: show 「インターネット接続エラーが発生しました。」 (raised globally) and keep
 * the screen and what the user typed. So a caller must not read "no answer" as a verdict: not as
 * an ended session, not as a site that does not exist, not as a missing permission.
 */
export const isUnansweredRequestError = (error: unknown): boolean =>
  (isAxiosError(error) && !error.response) ||
  (typeof navigator !== 'undefined' && navigator.onLine === false);
